// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@conklin/App/SharedStyles/CartLineSharedStyles";
import { TooltipPresentationProps } from "@conklin/MobiusOverrides/Tooltip";
import { rfqQuoteDetailsRequestedDetailsGridStyles } from "@conklin/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsRequestedDetailsGrid";
import { mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsRequestedDetailsGridStyles.productDescription = {
    ...cartLineSharedStyles.productDescription,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productImage = {
    ...cartLineSharedStyles.productImage,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};
rfqQuoteDetailsRequestedDetailsGridStyles.extendedUnitNetPriceText = {
    ...cartLineSharedStyles.extendedUnitNetPriceText,
};
rfqQuoteDetailsRequestedDetailsGridStyles.productPrice = {
    ...mergeWithCss(cartLineSharedStyles.productPrice, {
        priceLabelText: {
            css: css`
                ${xScreen("lte", "md")} {
                    display: block;
                }
            `,
        },
        quoteMessageWrapper: {
            css: css`
                display: flex;
                justify-content: flex-end;
                align-items: baseline;
            `,
        },
        quoteMessage: {
            tooltip: {
                extendedStyles: {
                    triggerWrapper: {
                        css: css`
                            margin-right: 0;
                        `,
                    },
                },
            } as TooltipPresentationProps,
        },
    }),
};

rfqQuoteDetailsRequestedDetailsGridStyles.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        width: 100%;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeGridItem = {
    width: 6,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.costCodeLabelText = {
    weight: "bold",
    css: css`
        margin-bottom: 10px;
        margin-right: 10px;
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.footerWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-end;
        margin-top: 20px;
        @media print {
            display: block;
        }
    `,
};

rfqQuoteDetailsRequestedDetailsGridStyles.cartLineContainer = {
    total: {
        css: css`
            display: flex;
            justify-content: flex-end;
            ${xScreen("lte", "md")} {
                grid-column: 3 / 6;
            }
        `,
    },
    qty: {
        css: css`
            ${xScreen("lte", "md")} {
                grid-column: 1 / 3;
            }
        `,
    },
};
